export default __webpack_public_path__ + "static/media/refer.a595eca9.svg";